import CustomSelect from '@/views/custom_select';
import ComposableForm from '@/views/composable_form';

let composableForm = null;

pageUnload('info_pages_show', () => {
  if (composableForm) {
    composableForm.destroy();
    composableForm = null;
  }
});

pageLoad('info_pages_show', () => {
  const formNode = document.querySelector('form#new_crm_lead');
  if (!formNode) { return; }

  // destroyed by the CustomSelect registry on turbolinks:before-cache
  new CustomSelect(formNode.querySelector('.b-input-v4.country_code'));

  composableForm = new ComposableForm(formNode, {
    fields: [
      formNode.querySelector('#crm_lead_client'),
      formNode.querySelector('#crm_lead_phone')
    ]
  });

  const privacyConsentNodes = [...formNode.querySelectorAll('.b-input-v4.privacy-consent')];
  if (privacyConsentNodes.length) {
    $(formNode)
      .on('submit', e => {
        privacyConsentNodes.forEach(node => {
          if (node.querySelector('input').checked) { return; }

          node.classList.add('field_with_errors');

          e.preventDefault();
          e.stopImmediatePropagation();
        });
      })
      .on('ajax:success', async e => {
        formNode.querySelectorAll('.b-input-v4 input').forEach(node => node.value = '');

        const { thanksModal } = await import(
          /* webpackChunkName: "modal" */
          '@/views/modal/thanks_modal'
        );
        thanksModal();

        // TODO: @blackchestnut, тут что-то должно быть?
        // track({ event: 'callback_form_sent', form_location: 'last_screen' });
      });

    privacyConsentNodes.forEach(node => {
      $(node).on('change', () => {
        node.classList.remove('field_with_errors');
      });
    });
  }
});
